


























































import Vue from "vue";
import Component from "vue-class-component";
import ViewAction from "@/data/ViewAction";
import { Prop } from "vue-property-decorator";

@Component
export default class ViewActionGroup extends Vue {
  @Prop({})
  readonly actions!: ViewAction[];

  @Prop({ default: false })
  readonly disabled!: boolean;

  @Prop({ default: "" })
  readonly disabledMessage!: string;
}
